module.exports = "/images/icon_social_insta.png?1f1e66b3501f87027f55ab9b20d319f9";